import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Create, FormManager, PageTitle, selectUser, UserState } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { Timetable } from 'timetable-model';
import { useSelector } from 'react-redux';

export const TimetableCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const user = useSelector((state: { user: UserState }) => selectUser(state));

  return (
    <>
      <PageTitle verb="Create" entity={Timetable} />
      {user.userId && (
        <FormManager
          compoundUrl="/main/~/timetable-create"
          handleCancel={() => navigate(`/admin/timetable/search`)}
          handleSuccess={({ keyOfFirstCreate }) => navigate(getListRowLink(Timetable.listRowLink, keyOfFirstCreate))}
          initialization={{
            main: {
              type: 'create-single',
              entity: Timetable,
              override: {
                institution_id: parseInt(user.orgPath),
              },
            },
          }}
        >
          <Create valuesKey="main" entity={Timetable} />
        </FormManager>
      )}
    </>
  );
};
